import { render, staticRenderFns } from "./CustomContract.vue?vue&type=template&id=8e646924"
import script from "./CustomContract.vue?vue&type=script&lang=js"
export * from "./CustomContract.vue?vue&type=script&lang=js"
import style0 from "./CustomContract.vue?vue&type=style&index=0&id=8e646924&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports